import Compiler, { GetValueFunction } from './evalSafelyCompiler';
import token from "./evalSafelyToken";

//Infix to postfix stack evaluator
const evalSafely = (expr: string, context?: any, option?: {
  getValue: GetValueFunction;
}) => {
    if(expr){
      const tokenList = token(expr);
      const compiler = new Compiler(tokenList, option && option.getValue);
      const astTree = compiler.parse();
      return compiler.calc(astTree, context || {});
    }
}

export default evalSafely;